/* global Sys, Services */
Sys.ns("Services");

/**
 * The Spin Service.
 *
 * @class Services.Spin
 * @extends Services.Base
 */
Services.Spin = {
    constructor: function(config) {
        var parsedResponse;

        Services.Spin.superclass.constructor.apply(this, arguments);
        parsedResponse = config.parsedResponse;
        this._isAnimating = false;
        this._isInSpiningState = false;

        if (parsedResponse.g4mode) {
            this._isQuickStopAvailable = false;
        }
        else if (!(typeof parsedResponse.config === "undefined") && !(typeof parsedResponse.config.gameParameters === "undefined") && !(typeof parsedResponse.config.gameParameters.quickStopAvailable === "undefined")) {
            this._isQuickStopAvailable = parsedResponse.config.gameParameters.quickStopAvailable;
        }
        else {
            this._isQuickStopAvailable = true;
        }
        this._hasQuickStopped = false;
    },

    _setupEvents: function() {
        this.observable.on({
            "notify:stateHandler.enteringSpinningState": this._spinStarted.bind(this),
            "notify:stateHandler.enteringStoppedState": this._spinEnded.bind(this)
        });
    },

    /**
     * Gets the state of animations for spin.
     *
     * @returns {boolean} Is spin is animating.
     */
    isAnimating: function() {
        return this._isAnimating;
    },

    /**
     * Gets the state of spin.
     *
     * @returns {boolean} Is game is in spinning state.
     */
    isInSpinningState: function() {
        return this._isInSpiningState;
    },

    /**
     * Quick stops the spin (if one is active and quick stop is available).
     *
     * @returns {void}
     */
    quickStop: function() {
        if (
            this.isInSpinningState() &&
            this.isQuickStopAvailable() &&
            !this._hasQuickStopped
        ) {
            this._quickStop();

            this._hasQuickStopped = true;

            this.publish("quickStopped");
        }
    },

    /**
     * Checks if quick stop is active.
     *
     * @returns {boolean} Whether or not quick stop is active.
     */
    isQuickStopAvailable: function() {
        return this._isQuickStopAvailable;
    },

    /**
     * Sets the status of spin animation.
     *
     * @returns {void}
     */
    setAnimationStarted: function() {
        this._isAnimating = true;
        this.publish("animationStarted");
    },

    /**
     * Sets the status of spin animation.
     *
     * @returns {void}
     */
    setAnimationEnded: function() {
        this._isAnimating = false;
        this.publish("animationEnded");
    },

    /**
     * Handles a quick stop request.
     *
     * @private
     * @returns {void}
     */
    _quickStop: function() {
        this.observable.fireEvent("request:spin.quickStop");
    },

    /**
     * Sets the mode of spin to stated.
     *
     * @returns {void}
     */
    _spinStarted: function() {
        this._isInSpiningState = true;
        this._hasQuickStopped = false;
        this.publish("started");
    },

    /**
     * Sets the mode of spin to ended.
     *
     * @returns {void}
     */
    _spinEnded: function() {
        this._isInSpiningState = false;
        this.publish("ended");
    }
};

Services.Spin = Sys.extend(
    Services.Base,
    Services.Spin,
    "Services.Spin"
);
